import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  intranet: defineAsyncComponent(() => import("/app/layouts/intranet.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("/app/layouts/landing.vue").then(m => m.default || m))
}